import { render, staticRenderFns } from "./TrustBox.vue?vue&type=template&id=3863c250&scoped=true&"
import script from "./TrustBox.vue?vue&type=script&lang=js&"
export * from "./TrustBox.vue?vue&type=script&lang=js&"
import style0 from "./TrustBox.vue?vue&type=style&index=0&id=3863c250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3863c250",
  null
  
)

export default component.exports